import React from 'react';

const MultipleAccountsIcon = () => {
  return (
    <svg className='iconTop' width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='40.705' cy='50.625' r='24.375' stroke='#000' strokeWidth='2.5' />
      <path
        d='M5.93 91.81a1.25 1.25 0 0 0 2.046 1.439L5.93 91.81zm67.503 1.436a1.25 1.25 0 0 0 2.045-1.438l-2.045 1.438zm-65.457.003A40.008 40.008 0 0 1 40.704 76.25v-2.5A42.508 42.508 0 0 0 5.93 91.81l2.045 1.439zM40.704 76.25a40.008 40.008 0 0 1 32.729 16.996l2.045-1.438A42.508 42.508 0 0 0 40.704 73.75v2.5z'
        fill='#000'
      />
      <path
        d='M71.966 25.955a1.25 1.25 0 1 0 .678 2.406l-.678-2.406zm25.489 8.838-.95.811.95-.811zm5.322 10.838-1.223.256 1.223-.256zm-1.723 15.197 1.135.524-1.135-.523zM78.918 73.75a1.25 1.25 0 0 0 0 2.5v-2.5zm0 0a1.25 1.25 0 0 0 .001 2.5l-.001-2.5zm32.728 19.495a1.25 1.25 0 1 0 2.046-1.436l-2.046 1.436zM72.644 28.361a23.128 23.128 0 0 1 23.86 7.243l1.901-1.623a25.628 25.628 0 0 0-26.44-8.026l.679 2.406zm23.86 7.243a23.104 23.104 0 0 1 5.05 10.283l2.447-.511a25.606 25.606 0 0 0-5.596-11.395l-1.9 1.623zm5.05 10.283c.996 4.764.485 9.82-1.635 14.418l2.27 1.047a25.612 25.612 0 0 0 1.812-15.976l-2.447.511zm-1.635 14.418a23.128 23.128 0 0 1-21 13.445v2.5a25.627 25.627 0 0 0 23.27-14.898l-2.27-1.047zm-21 15.945a39.952 39.952 0 0 1 32.727 16.995l2.046-1.436A42.452 42.452 0 0 0 78.918 73.75l.001 2.5z'
        fill='var(--theme-primary, #810ea9)'
      />
    </svg>
  );
};

export default MultipleAccountsIcon;
